import PropTypes from 'prop-types';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import DividerSchema from './schema';

const DividerData = (props) => {
  const { data, block, onChangeBlock } = props;

  const schema = DividerSchema({ ...props });
  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeBlock={onChangeBlock}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
    />
  );
};

DividerData.propTypes = {
  data: PropTypes.shape({
    size: PropTypes.string,
    spacing: PropTypes.string,
  }),
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
};

export default DividerData;
